import getOwaWorkload from '../selectors/getOwaWorkload';
import type OwaWorkload from '../store/schema/OwaWorkload';

export function isHotkeyMapSupported(): boolean {
    const workload = getOwaWorkload();
    return workload === 1 || workload === 2 || workload === 4;
}
